// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"724d1a03","44":"df5c468b","267":"18508294","569":"ec099b16","638":"7c7103f2","801":"4047f18f","852":"3c9e1379"}[chunkId] + ".chunk.js";
};